import { Panel, PanelBody, PanelHeader } from "@itandi/itandi-bb-ui";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { CompanyStoreSettingForm } from "~/components/specifics/settings/company_store_settings/CompanyStoreSettingForm";
import type { ItandiAccount } from "~/models/ItandiAccount";

type Props = {
	session: ItandiAccount;
};

export function Page({ session }: Props) {
	if (session.store === null) {
		return null;
	}

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<Panel>
					<PanelHeader title="店舗項目設定" />
					<PanelBody>
						<CompanyStoreSettingForm companyStoreSetting={session.store} />
					</PanelBody>
				</Panel>
			</ClientSettingLayout>
		</DefaultV2>
	);
}
